// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "fleetdashboard/v1/fleetdashboard.proto" (package "fleetdashboard.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Internal and private fleet dashboard RPCs and protos
//
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { OnlineState } from "../../app/v1/app";
import { RegistryItem } from "../../app/v1/app";
import { OrganizationInvite } from "../../app/v1/app";
import { OrganizationMember } from "../../app/v1/app";
import { APIKeyWithAuthorizations } from "../../app/v1/app";
import { Fragment } from "../../app/v1/app";
import { Struct } from "../../google/protobuf/struct";
import { Timestamp } from "../../google/protobuf/timestamp";
/**
 * @generated from protobuf message fleetdashboard.v1.GetOrganizationSummaryRequest
 */
export interface GetOrganizationSummaryRequest {
    /**
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
    /**
     * @generated from protobuf field: repeated string fragment_ids = 2;
     */
    fragmentIds: string[];
}
/**
 * @generated from protobuf message fleetdashboard.v1.AggregatedSummary
 */
export interface AggregatedSummary {
    /**
     * @generated from protobuf field: google.protobuf.Timestamp when = 1;
     */
    when?: Timestamp;
    /**
     * @generated from protobuf field: double total_binary_data_synced = 2;
     */
    totalBinaryDataSynced: number;
    /**
     * @generated from protobuf field: double total_tabular_data_synced = 3;
     */
    totalTabularDataSynced: number;
    /**
     * @generated from protobuf field: double total_tabular_data_captured = 4;
     */
    totalTabularDataCaptured: number;
    /**
     * @generated from protobuf field: double total_binary_data_captured = 5;
     */
    totalBinaryDataCaptured: number;
}
/**
 * @generated from protobuf message fleetdashboard.v1.GetOrganizationSummaryResponse
 */
export interface GetOrganizationSummaryResponse {
    /**
     * @generated from protobuf field: int64 total_parts = 1;
     */
    totalParts: string;
    /**
     * @generated from protobuf field: int64 total_parts_online = 2;
     */
    totalPartsOnline: string;
    /**
     * @generated from protobuf field: int64 total_parts_awaiting_setup = 3;
     */
    totalPartsAwaitingSetup: string;
    /**
     * @generated from protobuf field: repeated fleetdashboard.v1.AggregatedSummary hourly = 4;
     */
    hourly: AggregatedSummary[];
}
/**
 * @generated from protobuf message fleetdashboard.v1.FragmentImport
 */
export interface FragmentImport {
    /**
     * @generated from protobuf field: string fragment_id = 1;
     */
    fragmentId: string;
    /**
     * @generated from protobuf field: optional string version = 2;
     */
    version?: string;
    /**
     * @generated from protobuf field: optional google.protobuf.Struct variables = 3;
     */
    variables?: Struct;
    /**
     * @generated from protobuf field: optional string prefix = 4;
     */
    prefix?: string;
}
/**
 * @generated from protobuf message fleetdashboard.v1.ResolveFragmentsRequest
 */
export interface ResolveFragmentsRequest {
    /**
     * @generated from protobuf field: repeated fleetdashboard.v1.FragmentImport fragment_imports = 1;
     */
    fragmentImports: FragmentImport[];
    /**
     * @generated from protobuf field: optional bool allow_missing_variables = 2;
     */
    allowMissingVariables?: boolean;
}
/**
 * @generated from protobuf message fleetdashboard.v1.ResolveFragmentsResponse
 */
export interface ResolveFragmentsResponse {
    /**
     * @generated from protobuf field: repeated fleetdashboard.v1.ResolvedFragment resolved_fragments = 1;
     */
    resolvedFragments: ResolvedFragment[];
}
/**
 * @generated from protobuf message fleetdashboard.v1.SourceFragment
 */
export interface SourceFragment {
    /**
     * @generated from protobuf field: viam.app.v1.Fragment fragment = 1;
     */
    fragment?: Fragment;
    /**
     * @generated from protobuf field: optional string prefix = 2;
     */
    prefix?: string;
}
/**
 * @generated from protobuf message fleetdashboard.v1.ResourceVariablePaths
 */
export interface ResourceVariablePaths {
    /**
     * @generated from protobuf field: string resource_section = 1;
     */
    resourceSection: string;
    /**
     * @generated from protobuf field: string resource_name = 2;
     */
    resourceName: string;
    /**
     * @generated from protobuf field: map<string, string> paths = 3;
     */
    paths: {
        [key: string]: string;
    };
}
/**
 * @generated from protobuf message fleetdashboard.v1.ResolvedFragment
 */
export interface ResolvedFragment {
    /**
     * @generated from protobuf field: string fragment_id = 1;
     */
    fragmentId: string;
    /**
     * @generated from protobuf field: google.protobuf.Struct fragment_config = 2;
     */
    fragmentConfig?: Struct;
    /**
     * @generated from protobuf field: repeated string missing_variables = 3;
     */
    missingVariables: string[];
    /**
     * @generated from protobuf field: optional string prefix = 4;
     */
    prefix?: string;
    /**
     * @generated from protobuf field: optional string error = 5;
     */
    error?: string;
    /**
     * @generated from protobuf field: string name = 6;
     */
    name: string;
    /**
     * @generated from protobuf field: string organization_name = 7;
     */
    organizationName: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_updated = 8;
     */
    lastUpdated?: Timestamp;
    /**
     * @generated from protobuf field: repeated fleetdashboard.v1.SourceFragment source_fragments = 9;
     */
    sourceFragments: SourceFragment[];
    /**
     * @generated from protobuf field: repeated fleetdashboard.v1.ResourceVariablePaths variable_paths = 10;
     */
    variablePaths: ResourceVariablePaths[];
    /**
     * public_namespace is the owning organization's public namespace, or unset
     * when the org has none. Distinct from organization_name (the org's display
     * name, only populated for fragments owned by the requesting user's orgs).
     *
     * @generated from protobuf field: optional string public_namespace = 11;
     */
    publicNamespace?: string;
}
/**
 * @generated from protobuf message fleetdashboard.v1.ListLocationKeysRequest
 */
export interface ListLocationKeysRequest {
    /**
     * @generated from protobuf field: string location_id = 1;
     */
    locationId: string;
}
/**
 * @generated from protobuf message fleetdashboard.v1.ListLocationKeysResponse
 */
export interface ListLocationKeysResponse {
    /**
     * @generated from protobuf field: repeated viam.app.v1.APIKeyWithAuthorizations api_keys = 1;
     */
    apiKeys: APIKeyWithAuthorizations[];
}
/**
 * @generated from protobuf message fleetdashboard.v1.ListLocationMembersRequest
 */
export interface ListLocationMembersRequest {
    /**
     * @generated from protobuf field: string location_id = 1;
     */
    locationId: string;
}
/**
 * @generated from protobuf message fleetdashboard.v1.ListLocationMembersResponse
 */
export interface ListLocationMembersResponse {
    /**
     * @generated from protobuf field: string location_id = 1;
     */
    locationId: string;
    /**
     * @generated from protobuf field: repeated viam.app.v1.OrganizationMember members = 2;
     */
    members: OrganizationMember[];
    /**
     * @generated from protobuf field: repeated viam.app.v1.OrganizationInvite invites = 3;
     */
    invites: OrganizationInvite[];
}
/**
 * @generated from protobuf message fleetdashboard.v1.ConfigurationBlock
 */
export interface ConfigurationBlock {
    /**
     * @generated from protobuf oneof: block
     */
    block: {
        oneofKind: "registryItem";
        /**
         * @generated from protobuf field: viam.app.v1.RegistryItem registry_item = 1;
         */
        registryItem: RegistryItem;
    } | {
        oneofKind: "fragment";
        /**
         * @generated from protobuf field: viam.app.v1.Fragment fragment = 2;
         */
        fragment: Fragment;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: optional int64 usage = 5;
     */
    usage?: string;
    /**
     * Set when this hit is one Viam application of a module. The registry item
     * then carries that app and not the module's models, so a module with several
     * apps is several hits.
     *
     * @generated from protobuf field: optional string matched_app_name = 6;
     */
    matchedAppName?: string;
}
/**
 * @generated from protobuf message fleetdashboard.v1.SearchConfigurationBlocksRequest
 */
export interface SearchConfigurationBlocksRequest {
    /**
     * @generated from protobuf field: optional string organization_id = 1;
     */
    organizationId?: string;
    /**
     * @generated from protobuf field: optional string search_term = 2;
     */
    searchTerm?: string;
    /**
     * @generated from protobuf field: optional int32 limit = 3;
     */
    limit?: number;
    /**
     * @generated from protobuf field: optional int32 skip = 4;
     */
    skip?: number;
    /**
     * @generated from protobuf field: optional bool ai_mode = 5;
     */
    aiMode?: boolean;
    /**
     * @generated from protobuf field: optional string current_config_json = 6;
     */
    currentConfigJson?: string;
    /**
     * @generated from protobuf field: optional string part_id = 7;
     */
    partId?: string;
    /**
     * Empty means module + fragment. Pass ML_MODEL / ML_TRAINING / APPLICATION to include those kinds.
     *
     * @generated from protobuf field: repeated fleetdashboard.v1.ConfigurationBlockKind kinds = 8;
     */
    kinds: ConfigurationBlockKind[];
    /**
     * When true, deprecated registry items are included. Default false.
     *
     * @generated from protobuf field: optional bool include_deprecated = 9;
     */
    includeDeprecated?: boolean;
}
/**
 * @generated from protobuf message fleetdashboard.v1.SearchConfigurationBlocksResponse
 */
export interface SearchConfigurationBlocksResponse {
    /**
     * @generated from protobuf field: repeated fleetdashboard.v1.ConfigurationBlock items = 1;
     */
    items: ConfigurationBlock[];
    /**
     * @generated from protobuf field: optional string interpreted_term = 2;
     */
    interpretedTerm?: string;
}
/**
 * @generated from protobuf message fleetdashboard.v1.GetDebugConfigurationRequest
 */
export interface GetDebugConfigurationRequest {
    /**
     * @generated from protobuf field: string part_id = 1;
     */
    partId: string;
}
/**
 * @generated from protobuf message fleetdashboard.v1.GetDebugConfigurationResponse
 */
export interface GetDebugConfigurationResponse {
    /**
     * @generated from protobuf field: string config_json = 1;
     */
    configJson: string;
}
/**
 * @generated from protobuf message fleetdashboard.v1.CheckRobotPartConfigMergeSafetyRequest
 */
export interface CheckRobotPartConfigMergeSafetyRequest {
    /**
     * @generated from protobuf field: string part_id = 1;
     */
    partId: string;
    /**
     * The time of the update from which proposed_config
     * branched from the config history
     *
     * @generated from protobuf field: google.protobuf.Timestamp base_update_time = 2;
     */
    baseUpdateTime?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Struct proposed_config = 3;
     */
    proposedConfig?: Struct;
}
/**
 * @generated from protobuf message fleetdashboard.v1.CheckFragmentConfigMergeSafetyRequest
 */
export interface CheckFragmentConfigMergeSafetyRequest {
    /**
     * @generated from protobuf field: string fragment_id = 1;
     */
    fragmentId: string;
    /**
     * The time of the update from which proposed_config
     * branched from the config history
     *
     * @generated from protobuf field: google.protobuf.Timestamp base_update_time = 2;
     */
    baseUpdateTime?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Struct proposed_config = 3;
     */
    proposedConfig?: Struct;
}
/**
 * @generated from protobuf message fleetdashboard.v1.CheckRobotPartConfigMergeSafetyResponse
 */
export interface CheckRobotPartConfigMergeSafetyResponse {
    /**
     * @generated from protobuf field: bool merge_safe = 1;
     */
    mergeSafe: boolean;
    /**
     * The merged config that would be produced by MergeRobotPartConfig.
     * Only populated when merge_safe is true.
     *
     * @generated from protobuf field: optional google.protobuf.Struct merged_config = 2;
     */
    mergedConfig?: Struct;
}
/**
 * @generated from protobuf message fleetdashboard.v1.CheckFragmentConfigMergeSafetyResponse
 */
export interface CheckFragmentConfigMergeSafetyResponse {
    /**
     * @generated from protobuf field: bool merge_safe = 1;
     */
    mergeSafe: boolean;
    /**
     * The merged config that would be produced by MergeFragmentConfig.
     * Only populated when merge_safe is true.
     *
     * @generated from protobuf field: optional google.protobuf.Struct merged_config = 2;
     */
    mergedConfig?: Struct;
}
/**
 * @generated from protobuf message fleetdashboard.v1.MergeRobotPartConfigRequest
 */
export interface MergeRobotPartConfigRequest {
    /**
     * @generated from protobuf field: string part_id = 1;
     */
    partId: string;
    /**
     * The time of the update from which proposed_config
     * branched from the config history
     *
     * @generated from protobuf field: google.protobuf.Timestamp base_update_time = 2;
     */
    baseUpdateTime?: Timestamp;
    /**
     * The time of the last known update to the config history
     * If does not equal the latest config history entry,
     * the merge is out of sync and will fail
     *
     * @generated from protobuf field: google.protobuf.Timestamp last_known_config_history_time = 3;
     */
    lastKnownConfigHistoryTime?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Struct proposed_config = 4;
     */
    proposedConfig?: Struct;
}
/**
 * @generated from protobuf message fleetdashboard.v1.MergeRobotPartConfigResponse
 */
export interface MergeRobotPartConfigResponse {
    /**
     * @generated from protobuf field: google.protobuf.Struct merged_config = 1;
     */
    mergedConfig?: Struct;
}
/**
 * @generated from protobuf message fleetdashboard.v1.MergeFragmentConfigRequest
 */
export interface MergeFragmentConfigRequest {
    /**
     * @generated from protobuf field: string fragment_id = 1;
     */
    fragmentId: string;
    /**
     * The time of the update from which proposed_config
     * branched from the config history
     *
     * @generated from protobuf field: google.protobuf.Timestamp base_update_time = 2;
     */
    baseUpdateTime?: Timestamp;
    /**
     * The time of the last known update to the config history
     * If does not equal the latest config history entry,
     * the merge is out of sync and will fail
     *
     * @generated from protobuf field: google.protobuf.Timestamp last_known_config_history_time = 3;
     */
    lastKnownConfigHistoryTime?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Struct proposed_config = 4;
     */
    proposedConfig?: Struct;
}
/**
 * @generated from protobuf message fleetdashboard.v1.MergeFragmentConfigResponse
 */
export interface MergeFragmentConfigResponse {
    /**
     * @generated from protobuf field: google.protobuf.Struct merged_config = 1;
     */
    mergedConfig?: Struct;
}
/**
 * @generated from protobuf message fleetdashboard.v1.GetOrgModuleVersionSummariesRequest
 */
export interface GetOrgModuleVersionSummariesRequest {
    /**
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
}
/**
 * @generated from protobuf message fleetdashboard.v1.GetOrgModuleVersionSummariesResponse
 */
export interface GetOrgModuleVersionSummariesResponse {
    /**
     * @generated from protobuf field: repeated fleetdashboard.v1.ModuleVersionSummary module_version_summaries = 1;
     */
    moduleVersionSummaries: ModuleVersionSummary[];
}
/**
 * A count of parts using a specific version.
 * version is a string representation: semver for modules, revision number or tag for fragments,
 * or "latest" when no version is pinned.
 *
 * @generated from protobuf message fleetdashboard.v1.VersionCount
 */
export interface VersionCount {
    /**
     * @generated from protobuf field: string version = 1;
     */
    version: string;
    /**
     * @generated from protobuf field: int32 part_count = 2;
     */
    partCount: number;
    /**
     * The number of parts that can be upgraded
     * to the latest version, modulo platform support
     *
     * @generated from protobuf field: int32 part_upgrade_count = 3;
     */
    partUpgradeCount: number;
}
/**
 * A count of parts whose module config pins to a given pin expression.
 * Unlike VersionCount, this is keyed by the user-supplied pin syntax
 * from the part's module config (or from a fragment merged in), not by
 * the concrete package version the retriever picked. Use this to spot
 * auto-update intent ("latest", "^1", etc.) independently of what's
 * currently deployed. For reload-enabled modules the literal pin is
 * preserved as-is even though reload behavior shadows it at runtime.
 *
 * @generated from protobuf message fleetdashboard.v1.VersionPinCount
 */
export interface VersionPinCount {
    /**
     * @generated from protobuf field: string pin = 1;
     */
    pin: string;
    /**
     * @generated from protobuf field: int32 part_count = 2;
     */
    partCount: number;
}
/**
 * A summary of the versions of a module that are in use by parts in the organization.
 *
 * @generated from protobuf message fleetdashboard.v1.ModuleVersionSummary
 */
export interface ModuleVersionSummary {
    /**
     * @generated from protobuf field: string module_id = 1;
     */
    moduleId: string;
    /**
     * @generated from protobuf field: string module_name = 2;
     */
    moduleName: string;
    /**
     * The latest available version in the registry, not including rc
     *
     * @generated from protobuf field: string latest_version = 3;
     */
    latestVersion: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp latest_version_timestamp = 4;
     */
    latestVersionTimestamp?: Timestamp;
    /**
     * @generated from protobuf field: repeated fleetdashboard.v1.VersionCount versions = 5;
     */
    versions: VersionCount[];
    /**
     * Distribution of the version pins in the literal part config JSON blobs
     *
     * @generated from protobuf field: repeated fleetdashboard.v1.VersionPinCount version_pins = 6;
     */
    versionPins: VersionPinCount[];
}
/**
 * @generated from protobuf message fleetdashboard.v1.GetOrgFragmentVersionSummariesRequest
 */
export interface GetOrgFragmentVersionSummariesRequest {
    /**
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
}
/**
 * @generated from protobuf message fleetdashboard.v1.GetOrgFragmentVersionSummariesResponse
 */
export interface GetOrgFragmentVersionSummariesResponse {
    /**
     * @generated from protobuf field: repeated fleetdashboard.v1.FragmentVersionSummary fragment_version_summaries = 1;
     */
    fragmentVersionSummaries: FragmentVersionSummary[];
}
/**
 * A summary of the revisions of a fragment that are in use by parts in the organization.
 * Fragments version by monotonically increasing integer revision (and optional named tags),
 * so versions/latest_version are stringified revision numbers rather than semver.
 *
 * @generated from protobuf message fleetdashboard.v1.FragmentVersionSummary
 */
export interface FragmentVersionSummary {
    /**
     * @generated from protobuf field: string fragment_id = 1;
     */
    fragmentId: string;
    /**
     * @generated from protobuf field: string fragment_name = 2;
     */
    fragmentName: string;
    /**
     * The latest existing revision of the fragment, as a string.
     *
     * @generated from protobuf field: string latest_version = 3;
     */
    latestVersion: string;
    /**
     * When the latest revision was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp latest_version_timestamp = 4;
     */
    latestVersionTimestamp?: Timestamp;
    /**
     * Distribution of the concrete revisions resolved for the org's parts.
     *
     * @generated from protobuf field: repeated fleetdashboard.v1.VersionCount versions = 5;
     */
    versions: VersionCount[];
    /**
     * Distribution of the literal pins in the part/fragment config blobs
     * ("latest", a revision number, or a tag).
     *
     * @generated from protobuf field: repeated fleetdashboard.v1.VersionPinCount version_pins = 6;
     */
    versionPins: VersionPinCount[];
}
/**
 * @generated from protobuf message fleetdashboard.v1.GetOrgFragmentUsageRequest
 */
export interface GetOrgFragmentUsageRequest {
    /**
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
    /**
     * @generated from protobuf field: string fragment_id = 2;
     */
    fragmentId: string;
}
/**
 * @generated from protobuf message fleetdashboard.v1.GetOrgFragmentUsageResponse
 */
export interface GetOrgFragmentUsageResponse {
    /**
     * @generated from protobuf field: repeated fleetdashboard.v1.FragmentUsageRow usage = 1;
     */
    usage: FragmentUsageRow[];
}
/**
 * A single source (direct or via a parent fragment) by which a part uses the fragment.
 *
 * @generated from protobuf message fleetdashboard.v1.FragmentUsageSource
 */
export interface FragmentUsageSource {
    /**
     * @generated from protobuf field: fleetdashboard.v1.FragmentUsageSourceType type = 1;
     */
    type: FragmentUsageSourceType;
    /**
     * The literal pin at this source ("latest", a revision number, or a tag).
     *
     * @generated from protobuf field: string version_pin = 2;
     */
    versionPin: string;
    /**
     * Set only for NESTED: the fragment that imported this one.
     *
     * @generated from protobuf field: string parent_fragment_id = 3;
     */
    parentFragmentId: string;
    /**
     * Optional; UI can also map id->name from summaries.
     *
     * @generated from protobuf field: string parent_fragment_name = 4;
     */
    parentFragmentName: string;
}
/**
 * Per-part usage of one fragment. Mirrors registry.v1.RegistryItemUsage minus platform/reload.
 *
 * @generated from protobuf message fleetdashboard.v1.FragmentUsageRow
 */
export interface FragmentUsageRow {
    /**
     * @generated from protobuf field: string part_id = 1;
     */
    partId: string;
    /**
     * @generated from protobuf field: string part_name = 2;
     */
    partName: string;
    /**
     * @generated from protobuf field: string machine_id = 3;
     */
    machineId: string;
    /**
     * @generated from protobuf field: string machine_name = 4;
     */
    machineName: string;
    /**
     * @generated from protobuf field: string location_id = 5;
     */
    locationId: string;
    /**
     * @generated from protobuf field: string location_name = 6;
     */
    locationName: string;
    /**
     * @generated from protobuf field: string organization_id = 7;
     */
    organizationId: string;
    /**
     * @generated from protobuf field: string organization_name = 8;
     */
    organizationName: string;
    /**
     * First source's pin, surfaced for table convenience.
     *
     * @generated from protobuf field: string version_pin = 9;
     */
    versionPin: string;
    /**
     * Resolved revision (stringified int); "" if unresolved.
     *
     * @generated from protobuf field: string resolved_version = 10;
     */
    resolvedVersion: string;
    /**
     * @generated from protobuf field: viam.app.v1.OnlineState online_state = 11;
     */
    onlineState: OnlineState;
    /**
     * @generated from protobuf field: int64 seconds_since_online = 12;
     */
    secondsSinceOnline: string;
    /**
     * @generated from protobuf field: repeated fleetdashboard.v1.FragmentUsageSource sources = 13;
     */
    sources: FragmentUsageSource[];
}
/**
 * A block of content within an AssistantMessage, so the assistant chat can carry tool_use /
 * tool_result blocks alongside plain text.
 *
 * @generated from protobuf message fleetdashboard.v1.AssistantContentBlock
 */
export interface AssistantContentBlock {
    /**
     * @generated from protobuf oneof: block
     */
    block: {
        oneofKind: "text";
        /**
         * @generated from protobuf field: fleetdashboard.v1.AssistantTextBlock text = 1;
         */
        text: AssistantTextBlock;
    } | {
        oneofKind: "toolUse";
        /**
         * @generated from protobuf field: fleetdashboard.v1.AssistantToolUseBlock tool_use = 2;
         */
        toolUse: AssistantToolUseBlock;
    } | {
        oneofKind: "toolResult";
        /**
         * @generated from protobuf field: fleetdashboard.v1.AssistantToolResultBlock tool_result = 3;
         */
        toolResult: AssistantToolResultBlock;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message fleetdashboard.v1.AssistantTextBlock
 */
export interface AssistantTextBlock {
    /**
     * @generated from protobuf field: string text = 1;
     */
    text: string;
}
/**
 * AssistantToolUseBlock is the model asking to run a tool. Backend tools are executed server-side
 * in-loop; tools with no server executor are returned to the client to run (frontend tools).
 *
 * @generated from protobuf message fleetdashboard.v1.AssistantToolUseBlock
 */
export interface AssistantToolUseBlock {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * The tool input as a JSON object string.
     *
     * @generated from protobuf field: string input_json = 3;
     */
    inputJson: string;
}
/**
 * @generated from protobuf message fleetdashboard.v1.AssistantToolResultBlock
 */
export interface AssistantToolResultBlock {
    /**
     * @generated from protobuf field: string tool_use_id = 1;
     */
    toolUseId: string;
    /**
     * @generated from protobuf field: string content = 2;
     */
    content: string;
    /**
     * @generated from protobuf field: bool is_error = 3;
     */
    isError: boolean;
}
/**
 * One message in the assistant conversation.
 *
 * @generated from protobuf message fleetdashboard.v1.AssistantMessage
 */
export interface AssistantMessage {
    /**
     * @generated from protobuf field: fleetdashboard.v1.ConversationRole role = 1;
     */
    role: ConversationRole;
    /**
     * @generated from protobuf field: repeated fleetdashboard.v1.AssistantContentBlock content = 2;
     */
    content: AssistantContentBlock[];
}
/**
 * @generated from protobuf message fleetdashboard.v1.RunConfigAssistantTurnRequest
 */
export interface RunConfigAssistantTurnRequest {
    /**
     * The full conversation (oldest first), replayed each turn — the server is stateless.
     *
     * @generated from protobuf field: repeated fleetdashboard.v1.AssistantMessage messages = 1;
     */
    messages: AssistantMessage[];
    /**
     * Which config surface the chat was opened from.
     *
     * @generated from protobuf field: fleetdashboard.v1.ConfigType config_type = 2;
     */
    configType: ConfigType;
    /**
     * The machine id or fragment id the chat was opened from.
     *
     * @generated from protobuf field: string config_id = 3;
     */
    configId: string;
    /**
     * Org id; membership is validated server-side. The authoritative user id comes from auth state.
     *
     * @generated from protobuf field: optional string organization_id = 4;
     */
    organizationId?: string;
    /**
     * Groups the turns of one chat together in the persisted record.
     *
     * @generated from protobuf field: optional string conversation_id = 5;
     */
    conversationId?: string;
    /**
     * Which agent runs this turn. Omit or leave unspecified for the parent config assistant.
     *
     * @generated from protobuf field: optional fleetdashboard.v1.ConfigAssistantAgent agent = 6;
     */
    agent?: ConfigAssistantAgent;
    /**
     * Tool names the subagent may call. Required when agent is SUBAGENT; ignored for the parent.
     * Must be a subset of tools eligible for isolation (parent registry tools plus subagent-only
     * tools such as read/edit/check_inline_module_*); parent-only tools (e.g. suggest_save) are
     * refused even if listed.
     *
     * @generated from protobuf field: repeated string allowed_tools = 7;
     */
    allowedTools: string[];
}
/**
 * The result of one turn: the new messages the client should append and replay, why the model
 * stopped, and the turn's token usage.
 *
 * @generated from protobuf message fleetdashboard.v1.RunConfigAssistantTurnResponse
 */
export interface RunConfigAssistantTurnResponse {
    /**
     * @generated from protobuf field: repeated fleetdashboard.v1.AssistantMessage new_messages = 1;
     */
    newMessages: AssistantMessage[];
    /**
     * "end_turn" | "tool_use" | "max_tokens" | "model_context_window_exceeded" | ...
     *
     * @generated from protobuf field: string stop_reason = 2;
     */
    stopReason: string;
    /**
     * @generated from protobuf field: int32 input_tokens = 3;
     */
    inputTokens: number;
    /**
     * @generated from protobuf field: int32 output_tokens = 4;
     */
    outputTokens: number;
}
/**
 * Wraps the unary turn request so the streaming RPC takes the same fields without a second copy of
 * them drifting out of sync.
 *
 * @generated from protobuf message fleetdashboard.v1.StreamConfigAssistantTurnRequest
 */
export interface StreamConfigAssistantTurnRequest {
    /**
     * @generated from protobuf field: fleetdashboard.v1.RunConfigAssistantTurnRequest turn = 1;
     */
    turn?: RunConfigAssistantTurnRequest;
}
/**
 * One event in a streamed turn. Zero or more text_delta events arrive as the model writes, followed
 * by exactly one complete event carrying the same payload the unary RPC returns. A turn that fails
 * ends with a stream error and no complete event, so a client that never saw complete must treat
 * the turn as failed rather than as an empty answer.
 *
 * @generated from protobuf message fleetdashboard.v1.StreamConfigAssistantTurnResponse
 */
export interface StreamConfigAssistantTurnResponse {
    /**
     * @generated from protobuf oneof: event
     */
    event: {
        oneofKind: "textDelta";
        /**
         * The next chunk of assistant text. Deltas are for display only: they repeat text that also
         * arrives in complete, so a client must not append them to the replay wire.
         *
         * @generated from protobuf field: fleetdashboard.v1.ConfigAssistantTextDelta text_delta = 1;
         */
        textDelta: ConfigAssistantTextDelta;
    } | {
        oneofKind: "complete";
        /**
         * The finished turn. Always the last message on the stream.
         *
         * @generated from protobuf field: fleetdashboard.v1.RunConfigAssistantTurnResponse complete = 2;
         */
        complete: RunConfigAssistantTurnResponse;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message fleetdashboard.v1.ConfigAssistantTextDelta
 */
export interface ConfigAssistantTextDelta {
    /**
     * @generated from protobuf field: string text = 1;
     */
    text: string;
}
/**
 * @generated from protobuf message fleetdashboard.v1.ListConfigAssistantConversationsRequest
 */
export interface ListConfigAssistantConversationsRequest {
    /**
     * The machine id or fragment id whose conversations to list.
     *
     * @generated from protobuf field: string config_id = 1;
     */
    configId: string;
}
/**
 * @generated from protobuf message fleetdashboard.v1.ConfigAssistantConversationListItem
 */
export interface ConfigAssistantConversationListItem {
    /**
     * @generated from protobuf field: string conversation_id = 1;
     */
    conversationId: string;
    /**
     * The conversation's first user message.
     *
     * @generated from protobuf field: string title = 2;
     */
    title: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3;
     */
    updatedAt?: Timestamp;
}
/**
 * @generated from protobuf message fleetdashboard.v1.ListConfigAssistantConversationsResponse
 */
export interface ListConfigAssistantConversationsResponse {
    /**
     * Sorted by updated_at, newest first.
     *
     * @generated from protobuf field: repeated fleetdashboard.v1.ConfigAssistantConversationListItem conversations = 1;
     */
    conversations: ConfigAssistantConversationListItem[];
}
/**
 * @generated from protobuf message fleetdashboard.v1.GetConfigAssistantConversationRequest
 */
export interface GetConfigAssistantConversationRequest {
    /**
     * @generated from protobuf field: string conversation_id = 1;
     */
    conversationId: string;
}
/**
 * @generated from protobuf message fleetdashboard.v1.GetConfigAssistantConversationResponse
 */
export interface GetConfigAssistantConversationResponse {
    /**
     * The full conversation, oldest first.
     *
     * @generated from protobuf field: repeated fleetdashboard.v1.AssistantMessage messages = 1;
     */
    messages: AssistantMessage[];
    /**
     * Last turn's stop_reason (e.g. max_tokens, end_turn, tool_use). Empty on older records.
     *
     * @generated from protobuf field: string stop_reason = 2;
     */
    stopReason: string;
}
/**
 * @generated from protobuf message fleetdashboard.v1.SubmitConfigAssistantFeedbackRequest
 */
export interface SubmitConfigAssistantFeedbackRequest {
    /**
     * The conversation the feedback is about; the record is keyed by (conversation_id, authed user).
     *
     * @generated from protobuf field: string conversation_id = 1;
     */
    conversationId: string;
    /**
     * @generated from protobuf field: fleetdashboard.v1.FeedbackGrade grade = 2;
     */
    grade: FeedbackGrade;
    /**
     * A required note describing what went right or wrong.
     *
     * @generated from protobuf field: string comment = 3;
     */
    comment: string;
}
/**
 * @generated from protobuf message fleetdashboard.v1.SubmitConfigAssistantFeedbackResponse
 */
export interface SubmitConfigAssistantFeedbackResponse {
}
/**
 * @generated from protobuf message fleetdashboard.v1.GetConfigAssistantStatsRequest
 */
export interface GetConfigAssistantStatsRequest {
    /**
     * Start of the window, inclusive. Conversations are filtered and bucketed by the time they were
     * started (created_at). Unset defaults to 7 days before end.
     *
     * @generated from protobuf field: google.protobuf.Timestamp start = 1;
     */
    start?: Timestamp;
    /**
     * End of the window, exclusive. Unset defaults to now.
     *
     * @generated from protobuf field: google.protobuf.Timestamp end = 2;
     */
    end?: Timestamp;
}
/**
 * Per-model usage rollup. Token/turn totals attribute a conversation's accumulated usage to its
 * last-recorded model.
 *
 * @generated from protobuf message fleetdashboard.v1.ConfigAssistantModelStat
 */
export interface ConfigAssistantModelStat {
    /**
     * "opus" | "sonnet" | "" (unknown/legacy).
     *
     * @generated from protobuf field: string model = 1;
     */
    model: string;
    /**
     * @generated from protobuf field: int64 conversations = 2;
     */
    conversations: string;
    /**
     * @generated from protobuf field: int64 turns = 3;
     */
    turns: string;
    /**
     * @generated from protobuf field: int64 input_tokens = 4;
     */
    inputTokens: string;
    /**
     * @generated from protobuf field: int64 output_tokens = 5;
     */
    outputTokens: string;
}
/**
 * @generated from protobuf message fleetdashboard.v1.ConfigAssistantConfigTypeStat
 */
export interface ConfigAssistantConfigTypeStat {
    /**
     * "machine" | "fragment".
     *
     * @generated from protobuf field: string config_type = 1;
     */
    configType: string;
    /**
     * @generated from protobuf field: int64 conversations = 2;
     */
    conversations: string;
}
/**
 * @generated from protobuf message fleetdashboard.v1.ConfigAssistantStopReasonStat
 */
export interface ConfigAssistantStopReasonStat {
    /**
     * The conversation's last-recorded stop reason, e.g. "end_turn" | "tool_use" | "max_tokens".
     *
     * @generated from protobuf field: string stop_reason = 1;
     */
    stopReason: string;
    /**
     * @generated from protobuf field: int64 conversations = 2;
     */
    conversations: string;
}
/**
 * One row of the most-active-users leaderboard.
 *
 * @generated from protobuf message fleetdashboard.v1.ConfigAssistantUserStat
 */
export interface ConfigAssistantUserStat {
    /**
     * @generated from protobuf field: string user_id = 1;
     */
    userId: string;
    /**
     * Resolved email; empty when the user could not be resolved.
     *
     * @generated from protobuf field: string email = 2;
     */
    email: string;
    /**
     * @generated from protobuf field: int64 conversations = 3;
     */
    conversations: string;
    /**
     * @generated from protobuf field: int64 turns = 4;
     */
    turns: string;
    /**
     * @generated from protobuf field: int64 input_tokens = 5;
     */
    inputTokens: string;
    /**
     * @generated from protobuf field: int64 output_tokens = 6;
     */
    outputTokens: string;
    /**
     * @generated from protobuf field: int64 messages = 7;
     */
    messages: string;
    /**
     * The row's tokens split by model, so it can be priced with the same table as the totals.
     *
     * @generated from protobuf field: repeated fleetdashboard.v1.ConfigAssistantModelStat by_model = 8;
     */
    byModel: ConfigAssistantModelStat[];
}
/**
 * One row of the machine/fragment config leaderboard.
 *
 * @generated from protobuf message fleetdashboard.v1.ConfigAssistantConfigStat
 */
export interface ConfigAssistantConfigStat {
    /**
     * "machine" | "fragment".
     *
     * @generated from protobuf field: string config_type = 1;
     */
    configType: string;
    /**
     * Machine id for "machine", fragment id for "fragment".
     *
     * @generated from protobuf field: string config_id = 2;
     */
    configId: string;
    /**
     * Resolved machine or fragment name; empty when it is deleted or unreadable.
     *
     * @generated from protobuf field: string name = 3;
     */
    name: string;
    /**
     * @generated from protobuf field: int64 conversations = 4;
     */
    conversations: string;
    /**
     * @generated from protobuf field: int64 messages = 5;
     */
    messages: string;
    /**
     * @generated from protobuf field: int64 input_tokens = 6;
     */
    inputTokens: string;
    /**
     * @generated from protobuf field: int64 output_tokens = 7;
     */
    outputTokens: string;
    /**
     * The row's tokens split by model, so it can be priced with the same table as the totals.
     *
     * @generated from protobuf field: repeated fleetdashboard.v1.ConfigAssistantModelStat by_model = 8;
     */
    byModel: ConfigAssistantModelStat[];
}
/**
 * One row of the organization leaderboard.
 *
 * @generated from protobuf message fleetdashboard.v1.ConfigAssistantOrgStat
 */
export interface ConfigAssistantOrgStat {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
    /**
     * Resolved organization name; empty when it is deleted or unreadable.
     *
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: int64 conversations = 3;
     */
    conversations: string;
    /**
     * @generated from protobuf field: int64 messages = 4;
     */
    messages: string;
    /**
     * @generated from protobuf field: int64 input_tokens = 5;
     */
    inputTokens: string;
    /**
     * @generated from protobuf field: int64 output_tokens = 6;
     */
    outputTokens: string;
    /**
     * The row's tokens split by model, so it can be priced with the same table as the totals.
     *
     * @generated from protobuf field: repeated fleetdashboard.v1.ConfigAssistantModelStat by_model = 7;
     */
    byModel: ConfigAssistantModelStat[];
}
/**
 * How often one tool was called. uses counts every tool_use block; conversations counts the distinct
 * conversations that called it at least once.
 *
 * @generated from protobuf message fleetdashboard.v1.ConfigAssistantToolStat
 */
export interface ConfigAssistantToolStat {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * @generated from protobuf field: int64 uses = 2;
     */
    uses: string;
    /**
     * @generated from protobuf field: int64 conversations = 3;
     */
    conversations: string;
}
/**
 * How often one skill was loaded through the use_skill tool.
 *
 * @generated from protobuf message fleetdashboard.v1.ConfigAssistantSkillStat
 */
export interface ConfigAssistantSkillStat {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * @generated from protobuf field: int64 uses = 2;
     */
    uses: string;
    /**
     * @generated from protobuf field: int64 conversations = 3;
     */
    conversations: string;
}
/**
 * One UTC day of usage. Days with no conversations are omitted.
 *
 * @generated from protobuf message fleetdashboard.v1.ConfigAssistantDailyStat
 */
export interface ConfigAssistantDailyStat {
    /**
     * UTC day, "YYYY-MM-DD".
     *
     * @generated from protobuf field: string date = 1;
     */
    date: string;
    /**
     * @generated from protobuf field: int64 conversations = 2;
     */
    conversations: string;
    /**
     * @generated from protobuf field: int64 messages = 3;
     */
    messages: string;
    /**
     * @generated from protobuf field: int64 turns = 4;
     */
    turns: string;
    /**
     * @generated from protobuf field: int64 input_tokens = 5;
     */
    inputTokens: string;
    /**
     * @generated from protobuf field: int64 output_tokens = 6;
     */
    outputTokens: string;
    /**
     * Per-model token split, so a day's cost can be priced with the same table as the totals.
     *
     * @generated from protobuf field: repeated fleetdashboard.v1.ConfigAssistantModelStat by_model = 7;
     */
    byModel: ConfigAssistantModelStat[];
}
/**
 * One graded conversation with a written note.
 *
 * @generated from protobuf message fleetdashboard.v1.ConfigAssistantFeedbackNote
 */
export interface ConfigAssistantFeedbackNote {
    /**
     * @generated from protobuf field: string conversation_id = 1;
     */
    conversationId: string;
    /**
     * "positive" | "negative".
     *
     * @generated from protobuf field: string grade = 2;
     */
    grade: string;
    /**
     * @generated from protobuf field: string comment = 3;
     */
    comment: string;
    /**
     * @generated from protobuf field: string model = 4;
     */
    model: string;
    /**
     * @generated from protobuf field: string config_type = 5;
     */
    configType: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 6;
     */
    updatedAt?: Timestamp;
}
/**
 * Every total covers only the conversations started inside the requested window.
 *
 * @generated from protobuf message fleetdashboard.v1.GetConfigAssistantStatsResponse
 */
export interface GetConfigAssistantStatsResponse {
    /**
     * @generated from protobuf field: int64 total_conversations = 1;
     */
    totalConversations: string;
    /**
     * One turn is one backend round trip to the model, so a single question costs several turns when
     * the assistant loops through tools.
     *
     * @generated from protobuf field: int64 total_turns = 2;
     */
    totalTurns: string;
    /**
     * @generated from protobuf field: int64 total_input_tokens = 3;
     */
    totalInputTokens: string;
    /**
     * @generated from protobuf field: int64 total_output_tokens = 4;
     */
    totalOutputTokens: string;
    /**
     * @generated from protobuf field: int64 total_web_searches = 5;
     */
    totalWebSearches: string;
    /**
     * Summed generation time across all turns of all conversations.
     *
     * @generated from protobuf field: int64 total_duration_ms = 6;
     */
    totalDurationMs: string;
    /**
     * @generated from protobuf field: int64 positive_feedback = 9;
     */
    positiveFeedback: string;
    /**
     * @generated from protobuf field: int64 negative_feedback = 10;
     */
    negativeFeedback: string;
    /**
     * @generated from protobuf field: repeated fleetdashboard.v1.ConfigAssistantModelStat by_model = 11;
     */
    byModel: ConfigAssistantModelStat[];
    /**
     * @generated from protobuf field: repeated fleetdashboard.v1.ConfigAssistantConfigTypeStat by_config_type = 12;
     */
    byConfigType: ConfigAssistantConfigTypeStat[];
    /**
     * @generated from protobuf field: repeated fleetdashboard.v1.ConfigAssistantStopReasonStat by_stop_reason = 13;
     */
    byStopReason: ConfigAssistantStopReasonStat[];
    /**
     * Leaderboards, highest total tokens first.
     *
     * @generated from protobuf field: repeated fleetdashboard.v1.ConfigAssistantUserStat top_users = 14;
     */
    topUsers: ConfigAssistantUserStat[];
    /**
     * Newest graded conversations that carry a written note.
     *
     * @generated from protobuf field: repeated fleetdashboard.v1.ConfigAssistantFeedbackNote recent_feedback = 15;
     */
    recentFeedback: ConfigAssistantFeedbackNote[];
    /**
     * Every message stored on the conversations: user prompts, assistant replies, and the tool_result
     * messages the tool loop appends.
     *
     * @generated from protobuf field: int64 total_messages = 16;
     */
    totalMessages: string;
    /**
     * Just the messages a human typed.
     *
     * @generated from protobuf field: int64 total_user_prompts = 17;
     */
    totalUserPrompts: string;
    /**
     * Ascending by date; days with no conversations are omitted.
     *
     * @generated from protobuf field: repeated fleetdashboard.v1.ConfigAssistantDailyStat daily = 18;
     */
    daily: ConfigAssistantDailyStat[];
    /**
     * Most-used first.
     *
     * @generated from protobuf field: repeated fleetdashboard.v1.ConfigAssistantToolStat by_tool = 19;
     */
    byTool: ConfigAssistantToolStat[];
    /**
     * @generated from protobuf field: repeated fleetdashboard.v1.ConfigAssistantSkillStat by_skill = 20;
     */
    bySkill: ConfigAssistantSkillStat[];
    /**
     * @generated from protobuf field: repeated fleetdashboard.v1.ConfigAssistantConfigStat top_configs = 21;
     */
    topConfigs: ConfigAssistantConfigStat[];
    /**
     * @generated from protobuf field: repeated fleetdashboard.v1.ConfigAssistantOrgStat top_orgs = 22;
     */
    topOrgs: ConfigAssistantOrgStat[];
    /**
     * The window actually used: echoes the request, or the defaults applied for an unset bound.
     *
     * @generated from protobuf field: google.protobuf.Timestamp start = 23;
     */
    start?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp end = 24;
     */
    end?: Timestamp;
}
/**
 * duplicated from api because protos must be relative
 *
 * @generated from protobuf enum fleetdashboard.v1.FragmentVisibility
 */
export enum FragmentVisibility {
    /**
     * @generated from protobuf enum value: FRAGMENT_VISIBILITY_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: FRAGMENT_VISIBILITY_PRIVATE = 1;
     */
    PRIVATE = 1,
    /**
     * @generated from protobuf enum value: FRAGMENT_VISIBILITY_PUBLIC = 2;
     */
    PUBLIC = 2,
    /**
     * @generated from protobuf enum value: FRAGMENT_VISIBILITY_PUBLIC_UNLISTED = 3;
     */
    PUBLIC_UNLISTED = 3
}
/**
 * ConfigurationBlockKind selects which kinds of items SearchConfigurationBlocks queries.
 * Unspecified values are ignored. An empty kinds list means module + fragment
 * (the historical default). ML_MODEL, ML_TRAINING, and APPLICATION are opt-in.
 *
 * @generated from protobuf enum fleetdashboard.v1.ConfigurationBlockKind
 */
export enum ConfigurationBlockKind {
    /**
     * @generated from protobuf enum value: CONFIGURATION_BLOCK_KIND_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: CONFIGURATION_BLOCK_KIND_MODULE = 1;
     */
    MODULE = 1,
    /**
     * @generated from protobuf enum value: CONFIGURATION_BLOCK_KIND_FRAGMENT = 2;
     */
    FRAGMENT = 2,
    /**
     * @generated from protobuf enum value: CONFIGURATION_BLOCK_KIND_ML_MODEL = 3;
     */
    ML_MODEL = 3,
    /**
     * @generated from protobuf enum value: CONFIGURATION_BLOCK_KIND_ML_TRAINING = 4;
     */
    ML_TRAINING = 4,
    /**
     * A module's Viam application. One module can contribute several. Opt-in,
     * like ML_MODEL: an empty kinds list stays module + fragment.
     *
     * @generated from protobuf enum value: CONFIGURATION_BLOCK_KIND_APPLICATION = 5;
     */
    APPLICATION = 5
}
/**
 * @generated from protobuf enum fleetdashboard.v1.ConversationRole
 */
export enum ConversationRole {
    /**
     * @generated from protobuf enum value: CONVERSATION_ROLE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: CONVERSATION_ROLE_USER = 1;
     */
    USER = 1,
    /**
     * @generated from protobuf enum value: CONVERSATION_ROLE_ASSISTANT = 2;
     */
    ASSISTANT = 2
}
/**
 * How a part ends up using the fragment.
 *
 * @generated from protobuf enum fleetdashboard.v1.FragmentUsageSourceType
 */
export enum FragmentUsageSourceType {
    /**
     * @generated from protobuf enum value: FRAGMENT_USAGE_SOURCE_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * Listed in the part's own top-level fragments.
     *
     * @generated from protobuf enum value: FRAGMENT_USAGE_SOURCE_TYPE_DIRECT = 1;
     */
    DIRECT = 1,
    /**
     * Pulled in via a parent fragment.
     *
     * @generated from protobuf enum value: FRAGMENT_USAGE_SOURCE_TYPE_NESTED = 2;
     */
    NESTED = 2
}
/**
 * ConfigType is the config surface the assistant chat was opened from.
 *
 * @generated from protobuf enum fleetdashboard.v1.ConfigType
 */
export enum ConfigType {
    /**
     * @generated from protobuf enum value: CONFIG_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: CONFIG_TYPE_MACHINE = 1;
     */
    MACHINE = 1,
    /**
     * @generated from protobuf enum value: CONFIG_TYPE_FRAGMENT = 2;
     */
    FRAGMENT = 2
}
/**
 * Selects which config-assistant agent runs a turn. Unspecified is the parent config assistant.
 *
 * @generated from protobuf enum fleetdashboard.v1.ConfigAssistantAgent
 */
export enum ConfigAssistantAgent {
    /**
     * @generated from protobuf enum value: CONFIG_ASSISTANT_AGENT_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * Nested tool-chain subagent: advertises only allowed_tools from the request and uses a focused
     * summary-only system prompt. Used only by the client's nested loop for run_tool_chain_as_subagent;
     * the parent chat never sets this.
     *
     * @generated from protobuf enum value: CONFIG_ASSISTANT_AGENT_SUBAGENT = 1;
     */
    SUBAGENT = 1
}
/**
 * A thumbs-up/down grade on a config assistant conversation.
 *
 * @generated from protobuf enum fleetdashboard.v1.FeedbackGrade
 */
export enum FeedbackGrade {
    /**
     * @generated from protobuf enum value: FEEDBACK_GRADE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: FEEDBACK_GRADE_POSITIVE = 1;
     */
    POSITIVE = 1,
    /**
     * @generated from protobuf enum value: FEEDBACK_GRADE_NEGATIVE = 2;
     */
    NEGATIVE = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class GetOrganizationSummaryRequest$Type extends MessageType<GetOrganizationSummaryRequest> {
    constructor() {
        super("fleetdashboard.v1.GetOrganizationSummaryRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "fragment_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.GetOrganizationSummaryRequest
 */
export const GetOrganizationSummaryRequest = new GetOrganizationSummaryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AggregatedSummary$Type extends MessageType<AggregatedSummary> {
    constructor() {
        super("fleetdashboard.v1.AggregatedSummary", [
            { no: 1, name: "when", kind: "message", T: () => Timestamp },
            { no: 2, name: "total_binary_data_synced", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "total_tabular_data_synced", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "total_tabular_data_captured", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "total_binary_data_captured", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.AggregatedSummary
 */
export const AggregatedSummary = new AggregatedSummary$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOrganizationSummaryResponse$Type extends MessageType<GetOrganizationSummaryResponse> {
    constructor() {
        super("fleetdashboard.v1.GetOrganizationSummaryResponse", [
            { no: 1, name: "total_parts", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "total_parts_online", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 3, name: "total_parts_awaiting_setup", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 4, name: "hourly", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AggregatedSummary }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.GetOrganizationSummaryResponse
 */
export const GetOrganizationSummaryResponse = new GetOrganizationSummaryResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FragmentImport$Type extends MessageType<FragmentImport> {
    constructor() {
        super("fleetdashboard.v1.FragmentImport", [
            { no: 1, name: "fragment_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "version", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "variables", kind: "message", T: () => Struct },
            { no: 4, name: "prefix", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.FragmentImport
 */
export const FragmentImport = new FragmentImport$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResolveFragmentsRequest$Type extends MessageType<ResolveFragmentsRequest> {
    constructor() {
        super("fleetdashboard.v1.ResolveFragmentsRequest", [
            { no: 1, name: "fragment_imports", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FragmentImport },
            { no: 2, name: "allow_missing_variables", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.ResolveFragmentsRequest
 */
export const ResolveFragmentsRequest = new ResolveFragmentsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResolveFragmentsResponse$Type extends MessageType<ResolveFragmentsResponse> {
    constructor() {
        super("fleetdashboard.v1.ResolveFragmentsResponse", [
            { no: 1, name: "resolved_fragments", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ResolvedFragment }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.ResolveFragmentsResponse
 */
export const ResolveFragmentsResponse = new ResolveFragmentsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SourceFragment$Type extends MessageType<SourceFragment> {
    constructor() {
        super("fleetdashboard.v1.SourceFragment", [
            { no: 1, name: "fragment", kind: "message", T: () => Fragment },
            { no: 2, name: "prefix", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.SourceFragment
 */
export const SourceFragment = new SourceFragment$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResourceVariablePaths$Type extends MessageType<ResourceVariablePaths> {
    constructor() {
        super("fleetdashboard.v1.ResourceVariablePaths", [
            { no: 1, name: "resource_section", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "resource_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "paths", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.ResourceVariablePaths
 */
export const ResourceVariablePaths = new ResourceVariablePaths$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResolvedFragment$Type extends MessageType<ResolvedFragment> {
    constructor() {
        super("fleetdashboard.v1.ResolvedFragment", [
            { no: 1, name: "fragment_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "fragment_config", kind: "message", T: () => Struct },
            { no: 3, name: "missing_variables", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "prefix", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "error", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "organization_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "last_updated", kind: "message", T: () => Timestamp },
            { no: 9, name: "source_fragments", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SourceFragment },
            { no: 10, name: "variable_paths", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ResourceVariablePaths },
            { no: 11, name: "public_namespace", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.ResolvedFragment
 */
export const ResolvedFragment = new ResolvedFragment$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListLocationKeysRequest$Type extends MessageType<ListLocationKeysRequest> {
    constructor() {
        super("fleetdashboard.v1.ListLocationKeysRequest", [
            { no: 1, name: "location_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.ListLocationKeysRequest
 */
export const ListLocationKeysRequest = new ListLocationKeysRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListLocationKeysResponse$Type extends MessageType<ListLocationKeysResponse> {
    constructor() {
        super("fleetdashboard.v1.ListLocationKeysResponse", [
            { no: 1, name: "api_keys", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => APIKeyWithAuthorizations }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.ListLocationKeysResponse
 */
export const ListLocationKeysResponse = new ListLocationKeysResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListLocationMembersRequest$Type extends MessageType<ListLocationMembersRequest> {
    constructor() {
        super("fleetdashboard.v1.ListLocationMembersRequest", [
            { no: 1, name: "location_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.ListLocationMembersRequest
 */
export const ListLocationMembersRequest = new ListLocationMembersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListLocationMembersResponse$Type extends MessageType<ListLocationMembersResponse> {
    constructor() {
        super("fleetdashboard.v1.ListLocationMembersResponse", [
            { no: 1, name: "location_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "members", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => OrganizationMember },
            { no: 3, name: "invites", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => OrganizationInvite }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.ListLocationMembersResponse
 */
export const ListLocationMembersResponse = new ListLocationMembersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConfigurationBlock$Type extends MessageType<ConfigurationBlock> {
    constructor() {
        super("fleetdashboard.v1.ConfigurationBlock", [
            { no: 1, name: "registry_item", kind: "message", oneof: "block", T: () => RegistryItem },
            { no: 2, name: "fragment", kind: "message", oneof: "block", T: () => Fragment },
            { no: 5, name: "usage", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/ },
            { no: 6, name: "matched_app_name", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.ConfigurationBlock
 */
export const ConfigurationBlock = new ConfigurationBlock$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchConfigurationBlocksRequest$Type extends MessageType<SearchConfigurationBlocksRequest> {
    constructor() {
        super("fleetdashboard.v1.SearchConfigurationBlocksRequest", [
            { no: 1, name: "organization_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "search_term", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "limit", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "skip", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "ai_mode", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "current_config_json", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "part_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "kinds", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["fleetdashboard.v1.ConfigurationBlockKind", ConfigurationBlockKind, "CONFIGURATION_BLOCK_KIND_"] },
            { no: 9, name: "include_deprecated", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.SearchConfigurationBlocksRequest
 */
export const SearchConfigurationBlocksRequest = new SearchConfigurationBlocksRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchConfigurationBlocksResponse$Type extends MessageType<SearchConfigurationBlocksResponse> {
    constructor() {
        super("fleetdashboard.v1.SearchConfigurationBlocksResponse", [
            { no: 1, name: "items", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConfigurationBlock },
            { no: 2, name: "interpreted_term", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.SearchConfigurationBlocksResponse
 */
export const SearchConfigurationBlocksResponse = new SearchConfigurationBlocksResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDebugConfigurationRequest$Type extends MessageType<GetDebugConfigurationRequest> {
    constructor() {
        super("fleetdashboard.v1.GetDebugConfigurationRequest", [
            { no: 1, name: "part_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.GetDebugConfigurationRequest
 */
export const GetDebugConfigurationRequest = new GetDebugConfigurationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDebugConfigurationResponse$Type extends MessageType<GetDebugConfigurationResponse> {
    constructor() {
        super("fleetdashboard.v1.GetDebugConfigurationResponse", [
            { no: 1, name: "config_json", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.GetDebugConfigurationResponse
 */
export const GetDebugConfigurationResponse = new GetDebugConfigurationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CheckRobotPartConfigMergeSafetyRequest$Type extends MessageType<CheckRobotPartConfigMergeSafetyRequest> {
    constructor() {
        super("fleetdashboard.v1.CheckRobotPartConfigMergeSafetyRequest", [
            { no: 1, name: "part_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "base_update_time", kind: "message", T: () => Timestamp },
            { no: 3, name: "proposed_config", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.CheckRobotPartConfigMergeSafetyRequest
 */
export const CheckRobotPartConfigMergeSafetyRequest = new CheckRobotPartConfigMergeSafetyRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CheckFragmentConfigMergeSafetyRequest$Type extends MessageType<CheckFragmentConfigMergeSafetyRequest> {
    constructor() {
        super("fleetdashboard.v1.CheckFragmentConfigMergeSafetyRequest", [
            { no: 1, name: "fragment_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "base_update_time", kind: "message", T: () => Timestamp },
            { no: 3, name: "proposed_config", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.CheckFragmentConfigMergeSafetyRequest
 */
export const CheckFragmentConfigMergeSafetyRequest = new CheckFragmentConfigMergeSafetyRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CheckRobotPartConfigMergeSafetyResponse$Type extends MessageType<CheckRobotPartConfigMergeSafetyResponse> {
    constructor() {
        super("fleetdashboard.v1.CheckRobotPartConfigMergeSafetyResponse", [
            { no: 1, name: "merge_safe", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "merged_config", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.CheckRobotPartConfigMergeSafetyResponse
 */
export const CheckRobotPartConfigMergeSafetyResponse = new CheckRobotPartConfigMergeSafetyResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CheckFragmentConfigMergeSafetyResponse$Type extends MessageType<CheckFragmentConfigMergeSafetyResponse> {
    constructor() {
        super("fleetdashboard.v1.CheckFragmentConfigMergeSafetyResponse", [
            { no: 1, name: "merge_safe", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "merged_config", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.CheckFragmentConfigMergeSafetyResponse
 */
export const CheckFragmentConfigMergeSafetyResponse = new CheckFragmentConfigMergeSafetyResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MergeRobotPartConfigRequest$Type extends MessageType<MergeRobotPartConfigRequest> {
    constructor() {
        super("fleetdashboard.v1.MergeRobotPartConfigRequest", [
            { no: 1, name: "part_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "base_update_time", kind: "message", T: () => Timestamp },
            { no: 3, name: "last_known_config_history_time", kind: "message", T: () => Timestamp },
            { no: 4, name: "proposed_config", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.MergeRobotPartConfigRequest
 */
export const MergeRobotPartConfigRequest = new MergeRobotPartConfigRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MergeRobotPartConfigResponse$Type extends MessageType<MergeRobotPartConfigResponse> {
    constructor() {
        super("fleetdashboard.v1.MergeRobotPartConfigResponse", [
            { no: 1, name: "merged_config", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.MergeRobotPartConfigResponse
 */
export const MergeRobotPartConfigResponse = new MergeRobotPartConfigResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MergeFragmentConfigRequest$Type extends MessageType<MergeFragmentConfigRequest> {
    constructor() {
        super("fleetdashboard.v1.MergeFragmentConfigRequest", [
            { no: 1, name: "fragment_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "base_update_time", kind: "message", T: () => Timestamp },
            { no: 3, name: "last_known_config_history_time", kind: "message", T: () => Timestamp },
            { no: 4, name: "proposed_config", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.MergeFragmentConfigRequest
 */
export const MergeFragmentConfigRequest = new MergeFragmentConfigRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MergeFragmentConfigResponse$Type extends MessageType<MergeFragmentConfigResponse> {
    constructor() {
        super("fleetdashboard.v1.MergeFragmentConfigResponse", [
            { no: 1, name: "merged_config", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.MergeFragmentConfigResponse
 */
export const MergeFragmentConfigResponse = new MergeFragmentConfigResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOrgModuleVersionSummariesRequest$Type extends MessageType<GetOrgModuleVersionSummariesRequest> {
    constructor() {
        super("fleetdashboard.v1.GetOrgModuleVersionSummariesRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.GetOrgModuleVersionSummariesRequest
 */
export const GetOrgModuleVersionSummariesRequest = new GetOrgModuleVersionSummariesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOrgModuleVersionSummariesResponse$Type extends MessageType<GetOrgModuleVersionSummariesResponse> {
    constructor() {
        super("fleetdashboard.v1.GetOrgModuleVersionSummariesResponse", [
            { no: 1, name: "module_version_summaries", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ModuleVersionSummary }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.GetOrgModuleVersionSummariesResponse
 */
export const GetOrgModuleVersionSummariesResponse = new GetOrgModuleVersionSummariesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VersionCount$Type extends MessageType<VersionCount> {
    constructor() {
        super("fleetdashboard.v1.VersionCount", [
            { no: 1, name: "version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "part_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "part_upgrade_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.VersionCount
 */
export const VersionCount = new VersionCount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VersionPinCount$Type extends MessageType<VersionPinCount> {
    constructor() {
        super("fleetdashboard.v1.VersionPinCount", [
            { no: 1, name: "pin", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "part_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.VersionPinCount
 */
export const VersionPinCount = new VersionPinCount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ModuleVersionSummary$Type extends MessageType<ModuleVersionSummary> {
    constructor() {
        super("fleetdashboard.v1.ModuleVersionSummary", [
            { no: 1, name: "module_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "module_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "latest_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "latest_version_timestamp", kind: "message", T: () => Timestamp },
            { no: 5, name: "versions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => VersionCount },
            { no: 6, name: "version_pins", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => VersionPinCount }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.ModuleVersionSummary
 */
export const ModuleVersionSummary = new ModuleVersionSummary$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOrgFragmentVersionSummariesRequest$Type extends MessageType<GetOrgFragmentVersionSummariesRequest> {
    constructor() {
        super("fleetdashboard.v1.GetOrgFragmentVersionSummariesRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.GetOrgFragmentVersionSummariesRequest
 */
export const GetOrgFragmentVersionSummariesRequest = new GetOrgFragmentVersionSummariesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOrgFragmentVersionSummariesResponse$Type extends MessageType<GetOrgFragmentVersionSummariesResponse> {
    constructor() {
        super("fleetdashboard.v1.GetOrgFragmentVersionSummariesResponse", [
            { no: 1, name: "fragment_version_summaries", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FragmentVersionSummary }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.GetOrgFragmentVersionSummariesResponse
 */
export const GetOrgFragmentVersionSummariesResponse = new GetOrgFragmentVersionSummariesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FragmentVersionSummary$Type extends MessageType<FragmentVersionSummary> {
    constructor() {
        super("fleetdashboard.v1.FragmentVersionSummary", [
            { no: 1, name: "fragment_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "fragment_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "latest_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "latest_version_timestamp", kind: "message", T: () => Timestamp },
            { no: 5, name: "versions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => VersionCount },
            { no: 6, name: "version_pins", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => VersionPinCount }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.FragmentVersionSummary
 */
export const FragmentVersionSummary = new FragmentVersionSummary$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOrgFragmentUsageRequest$Type extends MessageType<GetOrgFragmentUsageRequest> {
    constructor() {
        super("fleetdashboard.v1.GetOrgFragmentUsageRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "fragment_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.GetOrgFragmentUsageRequest
 */
export const GetOrgFragmentUsageRequest = new GetOrgFragmentUsageRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOrgFragmentUsageResponse$Type extends MessageType<GetOrgFragmentUsageResponse> {
    constructor() {
        super("fleetdashboard.v1.GetOrgFragmentUsageResponse", [
            { no: 1, name: "usage", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FragmentUsageRow }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.GetOrgFragmentUsageResponse
 */
export const GetOrgFragmentUsageResponse = new GetOrgFragmentUsageResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FragmentUsageSource$Type extends MessageType<FragmentUsageSource> {
    constructor() {
        super("fleetdashboard.v1.FragmentUsageSource", [
            { no: 1, name: "type", kind: "enum", T: () => ["fleetdashboard.v1.FragmentUsageSourceType", FragmentUsageSourceType, "FRAGMENT_USAGE_SOURCE_TYPE_"] },
            { no: 2, name: "version_pin", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "parent_fragment_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "parent_fragment_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.FragmentUsageSource
 */
export const FragmentUsageSource = new FragmentUsageSource$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FragmentUsageRow$Type extends MessageType<FragmentUsageRow> {
    constructor() {
        super("fleetdashboard.v1.FragmentUsageRow", [
            { no: 1, name: "part_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "part_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "machine_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "machine_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "location_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "location_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "organization_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "version_pin", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "resolved_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "online_state", kind: "enum", T: () => ["viam.app.v1.OnlineState", OnlineState, "ONLINE_STATE_"] },
            { no: 12, name: "seconds_since_online", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 13, name: "sources", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FragmentUsageSource }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.FragmentUsageRow
 */
export const FragmentUsageRow = new FragmentUsageRow$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AssistantContentBlock$Type extends MessageType<AssistantContentBlock> {
    constructor() {
        super("fleetdashboard.v1.AssistantContentBlock", [
            { no: 1, name: "text", kind: "message", oneof: "block", T: () => AssistantTextBlock },
            { no: 2, name: "tool_use", kind: "message", oneof: "block", T: () => AssistantToolUseBlock },
            { no: 3, name: "tool_result", kind: "message", oneof: "block", T: () => AssistantToolResultBlock }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.AssistantContentBlock
 */
export const AssistantContentBlock = new AssistantContentBlock$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AssistantTextBlock$Type extends MessageType<AssistantTextBlock> {
    constructor() {
        super("fleetdashboard.v1.AssistantTextBlock", [
            { no: 1, name: "text", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.AssistantTextBlock
 */
export const AssistantTextBlock = new AssistantTextBlock$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AssistantToolUseBlock$Type extends MessageType<AssistantToolUseBlock> {
    constructor() {
        super("fleetdashboard.v1.AssistantToolUseBlock", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "input_json", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.AssistantToolUseBlock
 */
export const AssistantToolUseBlock = new AssistantToolUseBlock$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AssistantToolResultBlock$Type extends MessageType<AssistantToolResultBlock> {
    constructor() {
        super("fleetdashboard.v1.AssistantToolResultBlock", [
            { no: 1, name: "tool_use_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "content", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "is_error", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.AssistantToolResultBlock
 */
export const AssistantToolResultBlock = new AssistantToolResultBlock$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AssistantMessage$Type extends MessageType<AssistantMessage> {
    constructor() {
        super("fleetdashboard.v1.AssistantMessage", [
            { no: 1, name: "role", kind: "enum", T: () => ["fleetdashboard.v1.ConversationRole", ConversationRole, "CONVERSATION_ROLE_"] },
            { no: 2, name: "content", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AssistantContentBlock }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.AssistantMessage
 */
export const AssistantMessage = new AssistantMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RunConfigAssistantTurnRequest$Type extends MessageType<RunConfigAssistantTurnRequest> {
    constructor() {
        super("fleetdashboard.v1.RunConfigAssistantTurnRequest", [
            { no: 1, name: "messages", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AssistantMessage },
            { no: 2, name: "config_type", kind: "enum", T: () => ["fleetdashboard.v1.ConfigType", ConfigType, "CONFIG_TYPE_"] },
            { no: 3, name: "config_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "organization_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "conversation_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "agent", kind: "enum", opt: true, T: () => ["fleetdashboard.v1.ConfigAssistantAgent", ConfigAssistantAgent, "CONFIG_ASSISTANT_AGENT_"] },
            { no: 7, name: "allowed_tools", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.RunConfigAssistantTurnRequest
 */
export const RunConfigAssistantTurnRequest = new RunConfigAssistantTurnRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RunConfigAssistantTurnResponse$Type extends MessageType<RunConfigAssistantTurnResponse> {
    constructor() {
        super("fleetdashboard.v1.RunConfigAssistantTurnResponse", [
            { no: 1, name: "new_messages", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AssistantMessage },
            { no: 2, name: "stop_reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "input_tokens", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "output_tokens", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.RunConfigAssistantTurnResponse
 */
export const RunConfigAssistantTurnResponse = new RunConfigAssistantTurnResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StreamConfigAssistantTurnRequest$Type extends MessageType<StreamConfigAssistantTurnRequest> {
    constructor() {
        super("fleetdashboard.v1.StreamConfigAssistantTurnRequest", [
            { no: 1, name: "turn", kind: "message", T: () => RunConfigAssistantTurnRequest }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.StreamConfigAssistantTurnRequest
 */
export const StreamConfigAssistantTurnRequest = new StreamConfigAssistantTurnRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StreamConfigAssistantTurnResponse$Type extends MessageType<StreamConfigAssistantTurnResponse> {
    constructor() {
        super("fleetdashboard.v1.StreamConfigAssistantTurnResponse", [
            { no: 1, name: "text_delta", kind: "message", oneof: "event", T: () => ConfigAssistantTextDelta },
            { no: 2, name: "complete", kind: "message", oneof: "event", T: () => RunConfigAssistantTurnResponse }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.StreamConfigAssistantTurnResponse
 */
export const StreamConfigAssistantTurnResponse = new StreamConfigAssistantTurnResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConfigAssistantTextDelta$Type extends MessageType<ConfigAssistantTextDelta> {
    constructor() {
        super("fleetdashboard.v1.ConfigAssistantTextDelta", [
            { no: 1, name: "text", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.ConfigAssistantTextDelta
 */
export const ConfigAssistantTextDelta = new ConfigAssistantTextDelta$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListConfigAssistantConversationsRequest$Type extends MessageType<ListConfigAssistantConversationsRequest> {
    constructor() {
        super("fleetdashboard.v1.ListConfigAssistantConversationsRequest", [
            { no: 1, name: "config_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.ListConfigAssistantConversationsRequest
 */
export const ListConfigAssistantConversationsRequest = new ListConfigAssistantConversationsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConfigAssistantConversationListItem$Type extends MessageType<ConfigAssistantConversationListItem> {
    constructor() {
        super("fleetdashboard.v1.ConfigAssistantConversationListItem", [
            { no: 1, name: "conversation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.ConfigAssistantConversationListItem
 */
export const ConfigAssistantConversationListItem = new ConfigAssistantConversationListItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListConfigAssistantConversationsResponse$Type extends MessageType<ListConfigAssistantConversationsResponse> {
    constructor() {
        super("fleetdashboard.v1.ListConfigAssistantConversationsResponse", [
            { no: 1, name: "conversations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConfigAssistantConversationListItem }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.ListConfigAssistantConversationsResponse
 */
export const ListConfigAssistantConversationsResponse = new ListConfigAssistantConversationsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetConfigAssistantConversationRequest$Type extends MessageType<GetConfigAssistantConversationRequest> {
    constructor() {
        super("fleetdashboard.v1.GetConfigAssistantConversationRequest", [
            { no: 1, name: "conversation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.GetConfigAssistantConversationRequest
 */
export const GetConfigAssistantConversationRequest = new GetConfigAssistantConversationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetConfigAssistantConversationResponse$Type extends MessageType<GetConfigAssistantConversationResponse> {
    constructor() {
        super("fleetdashboard.v1.GetConfigAssistantConversationResponse", [
            { no: 1, name: "messages", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AssistantMessage },
            { no: 2, name: "stop_reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.GetConfigAssistantConversationResponse
 */
export const GetConfigAssistantConversationResponse = new GetConfigAssistantConversationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SubmitConfigAssistantFeedbackRequest$Type extends MessageType<SubmitConfigAssistantFeedbackRequest> {
    constructor() {
        super("fleetdashboard.v1.SubmitConfigAssistantFeedbackRequest", [
            { no: 1, name: "conversation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "grade", kind: "enum", T: () => ["fleetdashboard.v1.FeedbackGrade", FeedbackGrade, "FEEDBACK_GRADE_"] },
            { no: 3, name: "comment", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.SubmitConfigAssistantFeedbackRequest
 */
export const SubmitConfigAssistantFeedbackRequest = new SubmitConfigAssistantFeedbackRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SubmitConfigAssistantFeedbackResponse$Type extends MessageType<SubmitConfigAssistantFeedbackResponse> {
    constructor() {
        super("fleetdashboard.v1.SubmitConfigAssistantFeedbackResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.SubmitConfigAssistantFeedbackResponse
 */
export const SubmitConfigAssistantFeedbackResponse = new SubmitConfigAssistantFeedbackResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetConfigAssistantStatsRequest$Type extends MessageType<GetConfigAssistantStatsRequest> {
    constructor() {
        super("fleetdashboard.v1.GetConfigAssistantStatsRequest", [
            { no: 1, name: "start", kind: "message", T: () => Timestamp },
            { no: 2, name: "end", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.GetConfigAssistantStatsRequest
 */
export const GetConfigAssistantStatsRequest = new GetConfigAssistantStatsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConfigAssistantModelStat$Type extends MessageType<ConfigAssistantModelStat> {
    constructor() {
        super("fleetdashboard.v1.ConfigAssistantModelStat", [
            { no: 1, name: "model", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "conversations", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 3, name: "turns", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 4, name: "input_tokens", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 5, name: "output_tokens", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.ConfigAssistantModelStat
 */
export const ConfigAssistantModelStat = new ConfigAssistantModelStat$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConfigAssistantConfigTypeStat$Type extends MessageType<ConfigAssistantConfigTypeStat> {
    constructor() {
        super("fleetdashboard.v1.ConfigAssistantConfigTypeStat", [
            { no: 1, name: "config_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "conversations", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.ConfigAssistantConfigTypeStat
 */
export const ConfigAssistantConfigTypeStat = new ConfigAssistantConfigTypeStat$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConfigAssistantStopReasonStat$Type extends MessageType<ConfigAssistantStopReasonStat> {
    constructor() {
        super("fleetdashboard.v1.ConfigAssistantStopReasonStat", [
            { no: 1, name: "stop_reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "conversations", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.ConfigAssistantStopReasonStat
 */
export const ConfigAssistantStopReasonStat = new ConfigAssistantStopReasonStat$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConfigAssistantUserStat$Type extends MessageType<ConfigAssistantUserStat> {
    constructor() {
        super("fleetdashboard.v1.ConfigAssistantUserStat", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "conversations", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 4, name: "turns", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 5, name: "input_tokens", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 6, name: "output_tokens", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 7, name: "messages", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 8, name: "by_model", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConfigAssistantModelStat }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.ConfigAssistantUserStat
 */
export const ConfigAssistantUserStat = new ConfigAssistantUserStat$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConfigAssistantConfigStat$Type extends MessageType<ConfigAssistantConfigStat> {
    constructor() {
        super("fleetdashboard.v1.ConfigAssistantConfigStat", [
            { no: 1, name: "config_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "config_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "conversations", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 5, name: "messages", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 6, name: "input_tokens", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 7, name: "output_tokens", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 8, name: "by_model", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConfigAssistantModelStat }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.ConfigAssistantConfigStat
 */
export const ConfigAssistantConfigStat = new ConfigAssistantConfigStat$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConfigAssistantOrgStat$Type extends MessageType<ConfigAssistantOrgStat> {
    constructor() {
        super("fleetdashboard.v1.ConfigAssistantOrgStat", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "conversations", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 4, name: "messages", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 5, name: "input_tokens", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 6, name: "output_tokens", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 7, name: "by_model", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConfigAssistantModelStat }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.ConfigAssistantOrgStat
 */
export const ConfigAssistantOrgStat = new ConfigAssistantOrgStat$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConfigAssistantToolStat$Type extends MessageType<ConfigAssistantToolStat> {
    constructor() {
        super("fleetdashboard.v1.ConfigAssistantToolStat", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "uses", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 3, name: "conversations", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.ConfigAssistantToolStat
 */
export const ConfigAssistantToolStat = new ConfigAssistantToolStat$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConfigAssistantSkillStat$Type extends MessageType<ConfigAssistantSkillStat> {
    constructor() {
        super("fleetdashboard.v1.ConfigAssistantSkillStat", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "uses", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 3, name: "conversations", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.ConfigAssistantSkillStat
 */
export const ConfigAssistantSkillStat = new ConfigAssistantSkillStat$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConfigAssistantDailyStat$Type extends MessageType<ConfigAssistantDailyStat> {
    constructor() {
        super("fleetdashboard.v1.ConfigAssistantDailyStat", [
            { no: 1, name: "date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "conversations", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 3, name: "messages", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 4, name: "turns", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 5, name: "input_tokens", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 6, name: "output_tokens", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 7, name: "by_model", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConfigAssistantModelStat }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.ConfigAssistantDailyStat
 */
export const ConfigAssistantDailyStat = new ConfigAssistantDailyStat$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConfigAssistantFeedbackNote$Type extends MessageType<ConfigAssistantFeedbackNote> {
    constructor() {
        super("fleetdashboard.v1.ConfigAssistantFeedbackNote", [
            { no: 1, name: "conversation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "grade", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "comment", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "model", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "config_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "updated_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.ConfigAssistantFeedbackNote
 */
export const ConfigAssistantFeedbackNote = new ConfigAssistantFeedbackNote$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetConfigAssistantStatsResponse$Type extends MessageType<GetConfigAssistantStatsResponse> {
    constructor() {
        super("fleetdashboard.v1.GetConfigAssistantStatsResponse", [
            { no: 1, name: "total_conversations", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "total_turns", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 3, name: "total_input_tokens", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 4, name: "total_output_tokens", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 5, name: "total_web_searches", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 6, name: "total_duration_ms", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 9, name: "positive_feedback", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 10, name: "negative_feedback", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 11, name: "by_model", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConfigAssistantModelStat },
            { no: 12, name: "by_config_type", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConfigAssistantConfigTypeStat },
            { no: 13, name: "by_stop_reason", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConfigAssistantStopReasonStat },
            { no: 14, name: "top_users", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConfigAssistantUserStat },
            { no: 15, name: "recent_feedback", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConfigAssistantFeedbackNote },
            { no: 16, name: "total_messages", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 17, name: "total_user_prompts", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 18, name: "daily", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConfigAssistantDailyStat },
            { no: 19, name: "by_tool", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConfigAssistantToolStat },
            { no: 20, name: "by_skill", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConfigAssistantSkillStat },
            { no: 21, name: "top_configs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConfigAssistantConfigStat },
            { no: 22, name: "top_orgs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConfigAssistantOrgStat },
            { no: 23, name: "start", kind: "message", T: () => Timestamp },
            { no: 24, name: "end", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message fleetdashboard.v1.GetConfigAssistantStatsResponse
 */
export const GetConfigAssistantStatsResponse = new GetConfigAssistantStatsResponse$Type();
/**
 * @generated ServiceType for protobuf service fleetdashboard.v1.FleetDashboardService
 */
export const FleetDashboardService = new ServiceType("fleetdashboard.v1.FleetDashboardService", [
    { name: "GetOrganizationSummary", options: {}, I: GetOrganizationSummaryRequest, O: GetOrganizationSummaryResponse },
    { name: "ResolveFragments", options: {}, I: ResolveFragmentsRequest, O: ResolveFragmentsResponse },
    { name: "ListLocationKeys", options: {}, I: ListLocationKeysRequest, O: ListLocationKeysResponse },
    { name: "ListLocationMembers", options: {}, I: ListLocationMembersRequest, O: ListLocationMembersResponse },
    { name: "SearchConfigurationBlocks", options: {}, I: SearchConfigurationBlocksRequest, O: SearchConfigurationBlocksResponse },
    { name: "GetDebugConfiguration", options: {}, I: GetDebugConfigurationRequest, O: GetDebugConfigurationResponse },
    { name: "CheckRobotPartConfigMergeSafety", options: {}, I: CheckRobotPartConfigMergeSafetyRequest, O: CheckRobotPartConfigMergeSafetyResponse },
    { name: "CheckFragmentConfigMergeSafety", options: {}, I: CheckFragmentConfigMergeSafetyRequest, O: CheckFragmentConfigMergeSafetyResponse },
    { name: "MergeRobotPartConfig", options: {}, I: MergeRobotPartConfigRequest, O: MergeRobotPartConfigResponse },
    { name: "MergeFragmentConfig", options: {}, I: MergeFragmentConfigRequest, O: MergeFragmentConfigResponse },
    { name: "RunConfigAssistantTurn", options: {}, I: RunConfigAssistantTurnRequest, O: RunConfigAssistantTurnResponse },
    { name: "StreamConfigAssistantTurn", serverStreaming: true, options: {}, I: StreamConfigAssistantTurnRequest, O: StreamConfigAssistantTurnResponse },
    { name: "ListConfigAssistantConversations", options: {}, I: ListConfigAssistantConversationsRequest, O: ListConfigAssistantConversationsResponse },
    { name: "GetConfigAssistantConversation", options: {}, I: GetConfigAssistantConversationRequest, O: GetConfigAssistantConversationResponse },
    { name: "SubmitConfigAssistantFeedback", options: {}, I: SubmitConfigAssistantFeedbackRequest, O: SubmitConfigAssistantFeedbackResponse },
    { name: "GetConfigAssistantStats", options: {}, I: GetConfigAssistantStatsRequest, O: GetConfigAssistantStatsResponse },
    { name: "GetOrgModuleVersionSummaries", options: {}, I: GetOrgModuleVersionSummariesRequest, O: GetOrgModuleVersionSummariesResponse },
    { name: "GetOrgFragmentVersionSummaries", options: {}, I: GetOrgFragmentVersionSummariesRequest, O: GetOrgFragmentVersionSummariesResponse },
    { name: "GetOrgFragmentUsage", options: {}, I: GetOrgFragmentUsageRequest, O: GetOrgFragmentUsageResponse }
]);
